import { initializeApp } from 'firebase/app';
import { getRemoteConfig, getValue, RemoteConfig, fetchAndActivate } from 'firebase/remote-config';
import { PROJECT_ENVIRONMENT } from '@ax/env';

const app = initializeApp(PROJECT_ENVIRONMENT.FIREBASE_CONFIG);

export class FirebaseService {
  public remoteConfig: RemoteConfig;
  constructor() {
    this.remoteConfig = getRemoteConfig(app);
  }

  async fetchAndActivate() {
    try {
      await fetchAndActivate(this.remoteConfig);
    } catch (error) {
      console.log('error fetching remote config', error);
    }
  }

  getValue(key: string) {
    return getValue(this.remoteConfig, key);
  }
}
